import {Component, OnInit, ViewChild, Output, EventEmitter, ElementRef} from '@angular/core';
import { DocumentoDet } from 'src/app/models/DocumentoDet';
import { iconEliminar, GetDateTime, CodTipoFichaFUR, CodTipoFichaHe, GlobalVars, CodSubTipoFichaFUR, saveContent, iconVer, DscTituloPaginator, openModalMensaje, listTypesUpload, openModalMensajePrg, iconAgregar, strDscMsjPrgEliminar, isEmpty, isEmptyList, isNotEmptyList, listTypesUpload2, NumIdCargaTopeEvi, DscNomDoc, funcFechaActualAMPM, horaAMPM, ConvertDateTimeToStr2, ConvertDateTimeToStrForBD, NumIdTDEvidencia, strMatTablePaginator, DscMensajeSpinner, GetIdLS, NumIdEstadoRegFUR } from 'src/app/general/variables';
import { Fur } from 'src/app/models/Fur';
import { MatTableDataSource, MatSort, MatPaginator, MatDialog } from '@angular/material';
import { LaserFicheService } from 'src/app/services/laser-fiche.service';
import { LaserFiche } from 'src/app/models/LaserFiche';
import { Observable } from 'rxjs';
import { DocumentoDetService } from 'src/app/services/documento-det.service';
import { ActualizarDet } from 'src/app/models/DocumentoCab';
import { FiltrarListEvidencias } from 'src/app/general/Funciones';
import { ParametroService } from 'src/app/services/parametro.service';
import { DatePipe } from '@angular/common';
import { ArchivoBeanExt } from 'src/app/models/ArchivoBeanExt';
import { NgxSpinnerService } from 'ngx-spinner';
import {DomSanitizer} from '@angular/platform-browser';
import {FormGroup} from '@angular/forms';

@Component({
  selector: 'app-evidencias',
  templateUrl: './evidencias.component.html',
  styleUrls: ['./evidencias.component.css']
})
export class EvidenciasComponent implements OnInit {

  dataSource: MatTableDataSource<DocumentoDet>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  matTableColumnsDef = ['item', 'Nombre evidencia', 'FchHrreg', 'ver', 'eliminar'];

  strMatTablePaginator = strMatTablePaginator;

  iconoEliminar = iconEliminar;
  iconoVer = iconVer;
  dscExtensiones = listTypesUpload.join();
  strIdBtnFile = 'input_file';
  iconAgregar = iconAgregar;
  // strDscEtiqueta1:string = "(*.doc, *.pdf)";
  strDscEtiqueta2 = '(*.rar, *.zip, *.pdf, *.doc, *.docx, *.xls, *.xlsx, *.ppt, *.pptx, *.png, *.jpeg, *.jpg, *.gif, *.xps, *.txt, *.Gz, *.mp4, *.avi, *.mkv, *.flv, *.m4a, *.mp3, *.wav)';
  strDscEtiqueta1 = 'Seleccione el archivo';

  strDscColEtiq1 = 'Descripción';

  matTableColumnsEtiq = ['Ítem', this.strDscColEtiq1, 'Fecha y Hora Registro', 'Visualizar', 'Eliminar'];

  // flgLectura : boolean = false;

  fileToUpload: File = null;
  listFilesEvidencias: File[] = [];
  otra_instancia: false;
  cuenta_pruebas = false;
  require_identificarse: false;
  flgSoloLectura = false;
  evidenciaFile = '';
  strCodTipoFicha = CodTipoFichaFUR;
  strCodSubTipoFicha = CodSubTipoFichaFUR;
  strDscTitulo = 'Lista de Pruebas de hechos';
  numIdTipoFicha = null;
  isNotEmptyList = isNotEmptyList;
  numTopeMB: number = null;
  DscMensajeSpinner = DscMensajeSpinner;
  // flgModoOutput = false;
  strDesEvidencia = '';
  listEvidencias: DocumentoDet[] = [];

  @ViewChild("formReg") myFormRegister: ElementRef;
  @ViewChild("formUpload") myFormUpload: ElementRef;
  @ViewChild("simpleInput") myFileInput: ElementRef;
  @ViewChild("iframeUpload") myIframeUpload: ElementRef;
  @ViewChild("divContentInputFile") myDivInputFile: ElementRef;

  constructor(protected laserFicheService: LaserFicheService,
              protected documentoDetService: DocumentoDetService,
              public dialog: MatDialog,
              protected parametroService: ParametroService,
              public datepipe: DatePipe,
              private spinner: NgxSpinnerService,
              private sanitizer: DomSanitizer
    ) { }

  ngOnInit() {


    if (this.paginator != null) {this.paginator._intl.itemsPerPageLabel = DscTituloPaginator; } // this.paginator._intl.itemsPerPageLabel = DscTituloPaginator;
    this.numTopeMB = 20;

    this.parametroService.obtenerParametro(NumIdCargaTopeEvi).subscribe(
      data => {
        this.numTopeMB = 20;
        this.strDscEtiqueta2 = 'Máximo ' + this.numTopeMB.toString() + 'Mb por archivo. ' + this.strDscEtiqueta2;
      });

  }

  setStrDscColEtiq1(dato: string) {

    this.strDscColEtiq1 = dato;

  }

  setStrIdBtnFile(strDscId: string) {

    this.strIdBtnFile = strDscId;

  }



  setStrDscEtiqueta1(strDato: string) {

    this.strDscEtiqueta1 = strDato;

  }



  getEvidenciasC() {

    return this.listEvidencias;

  }




  _verArchivo(index: number) {



    let vBase64 = this.listEvidencias[index].fileBase64;
    const vFileName = this.listEvidencias[index].cdocumentoDscnombre;

    if (isEmpty(vBase64)) {

      vBase64 = this.listEvidencias[index].cdocumentoDscurl;

    }

    saveContent(vBase64, vFileName);


  }

  _eliminar(ev) {

    openModalMensajePrg(this.strDscTitulo, strDscMsjPrgEliminar, this.dialog).subscribe(result => {

      // if(result != true)
      if (result == false) {

        this.listEvidencias.splice(this.listEvidencias.indexOf(ev), 1);

        this.listFilesEvidencias.forEach(fileV => {

            if (ev.cdocumentoDscNombre == fileV.name) {
              this.listFilesEvidencias.splice(this.listFilesEvidencias.indexOf(fileV), 1);
            }
        });
        this._cargarTableMaterial();


      }

    });


  }

  setEvidenciaC(fur: Fur) {

    this.listEvidencias = FiltrarListEvidencias(fur.listaDocumentoAdjuntoDet);

    this.listEvidencias.forEach(element => {


      element.strDdocumentoFchregAMPM = element.strDdocumentoFchreg.substr(0, 10) + ' ' +  horaAMPM(element.ddocumentoFchreg);

    });


    this._cargarTableMaterial();
  }



  setFichaDocumento(codTipoFicha: string, codSubtipoFicha: string, idTipoFicha: number) {

    this.strCodTipoFicha = codTipoFicha;
    this.strCodSubTipoFicha = codSubtipoFicha;
    this.numIdTipoFicha = idTipoFicha;

  }


  setEvidenciaGeneral(listaDocumentoDet: DocumentoDet[]) {

    this.listEvidencias = listaDocumentoDet;

    this._cargarTableMaterial();

  }

  evidenciaCReadEnable() {
    this.flgSoloLectura = true;
    // console.log(this.listEvidencias);
  }

  evidenciaCReadDisable() {
    this.flgSoloLectura = false;
    // console.log(this.listEvidencias);
  }

  _cargarTableMaterial() {

    setTimeout(() => {


      this.dataSource = new MatTableDataSource(this.listEvidencias);
      if (this.paginator != null) {
          this.paginator._intl.itemsPerPageLabel = DscTituloPaginator;

        } // this.paginator._intl.itemsPerPageLabel = DscTituloPaginator;
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;

    }, 1);

  }


  setEvidenciaTitulo(param: string) {

    this.strDscTitulo = param;

  }

  setSoloLectura(flgParam: boolean) {

    this.flgSoloLectura = flgParam;

  }

  archivosAlfresco = [];
  urlIframe = '';
  hkey = '';
  idArchivoAlfresco;
  myDivInputFileDisabled = false;
  formRegister: FormGroup;
  formUpload: FormGroup;

  uploadFileAlfresco(event) {
    this.myDivInputFileDisabled = true;
    let newItem;
    if (event.target.files.length > 0) {


      for (let file of event.target.files) {

        const fileSizeMB = Math.round(file.size / (1024 * 1024));


        for(let listaAlfresco of this.archivosAlfresco){
          let cleanName = listaAlfresco.name.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g,'_');
          let cleanFileName = file.name.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g,'_');
          if(cleanName == cleanFileName){
            //this.modal("El archivo ya se encuentra en la lista, seleccione otro archivo.");
            openModalMensaje('Evidencias', 'El archivo ya se encuentra en la lista, seleccione otro archivo.', this.dialog);
            this.myFileInput.nativeElement.value = "";
            this.myDivInputFileDisabled = false;
            return;
          }
        }

        if (fileSizeMB > 1024) {
          //this.modal("El tamaño máximo es de 1gb. revisa el tamaño de los archivos que intenta cargar.");
          openModalMensaje('Evidencias', 'El tamaño máximo es de 1gb. revisa el tamaño de los archivos que intenta cargar.', this.dialog);
          console.log("fileSizeMB::::::::::::", fileSizeMB);
          this.myFileInput.nativeElement.value = "";
          this.myDivInputFileDisabled = false;
          return;
        }

        if (!(file.name.toLowerCase().includes(".pdf") ||
          file.name.toLowerCase().includes(".xpdf") ||
          file.name.toLowerCase().includes(".doc") ||
          file.name.toLowerCase().includes(".docx") ||
          file.name.toLowerCase().includes(".xls") ||
          file.name.toLowerCase().includes(".xlsx") ||
          file.name.toLowerCase().includes(".mp4") ||
          file.name.toLowerCase().includes(".mp3") ||
          file.name.toLowerCase().includes(".jpg") ||
          file.name.toLowerCase().includes(".zip") ||
          file.name.toLowerCase().includes(".rar") ||
          file.name.toLowerCase().includes(".dwg") ||
          file.name.toLowerCase().includes(".ppt") ||
          file.name.toLowerCase().includes(".pptx") ||
          file.name.toLowerCase().includes(".png"))) {
          //this.modal("Los formatos permitidos son .pdf, .xpdf, .doc, .docx, .xls, .xlsx, .mp4, .jpg, .png, .zip, .rar, dwg, .mp3 revisa el formato del archivo que intenta cargar");
          openModalMensaje('Evidencias', 'Los formatos permitidos son .pdf, .xpdf, .doc, .docx, .xls, .xlsx, .mp4, .jpg, .png, .zip, .rar, dwg, .mp3 revisa el formato del archivo que intenta cargar', this.dialog);

          this.myFileInput.nativeElement.value = "";
          this.myDivInputFileDisabled = false;
          return;
        }

        let fileSize;
        if (fileSizeMB <= 0) {
          fileSize = Math.round(file.size / 1024) + ' KB'
        } else {
          fileSize = fileSizeMB + 'MB';
        }

        // REEMPLAZAR CARACATERES ESPECIALES NO SOPORTADOS POR ALFRESCO
        let fileNameArray = file.name.split('.');
        let realFileName = '';
        for (let i = 0; i < fileNameArray.length - 1 ; i++) {
          realFileName += fileNameArray[i];
        }
        realFileName = realFileName.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g,'_');

        newItem = {
          'name': realFileName + '.' + fileNameArray[fileNameArray.length - 1],
          'size': fileSize,
          'status': '0',
          'uuid': '',
          'idArchivoalfresco':'0',
          'data' : {}
        }

        this.archivosAlfresco.push(newItem);
      }


      // OBTENER DATOS DE CARGA
      const data = {
        "tipoArchivo": "MPV",
        "pathAlfresco": "file.path.compromiso.ambiental"
      }

      this.laserFicheService.agregarArchivo2(data).subscribe(resp => {
          console.log('agregarArchivo2');
        console.log(resp);

        if (resp.estado) {
          this.urlIframe = resp.formActionURL;
          this.hkey = resp.keyId;
          this.idArchivoAlfresco = resp.idArchivo;
          // jcmf
          setTimeout(() => {
            console.log("settimeout");
            this.myFormUpload.nativeElement.appendChild(this.myFormRegister.nativeElement.querySelector('input[type=file]'));
            this.myFormUpload.nativeElement.submit();
          }, 500);

          this.myDivInputFileDisabled = false;
        } else {
          this.myDivInputFileDisabled = false;
          this.archivosAlfresco.pop();
          //this.modalError("Tenemos problemas para realizar la carga de archivos.");
          openModalMensaje('Evidencias', 'Tenemos problemas para realizar la carga de archivos.', this.dialog);

        }
      },
        err => {

          this.myDivInputFileDisabled = false;
          this.archivosAlfresco.pop();
          openModalMensaje('Evidencias', 'Tenemos problemas para realizar la carga de archivos.', this.dialog);

        });



    }
  }
  removeArchivoAlfresco(item: any, i: number) {
    console.log('removeArchivoAlfresco',item,i);
    if (item.status != '0') {
      this.archivosAlfresco.splice(i, 1);
    }
  }

  iframeURL(url) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }


  iframeLoaded() {
    if (this.idArchivoAlfresco == null) {
      return;
    }

    this.laserFicheService.getByIdArchivo(this.idArchivoAlfresco).subscribe(resp => {
      console.log("resp", resp);
      this.myFileInput.nativeElement.value = "";
      let statusCheck = false;
      this.archivosAlfresco.forEach(function (archivo, i) {
        console.log("archivo00", archivo);
        console.log("index00", i);
        if (archivo.status == '0'   && !statusCheck) {
          archivo.status = '1';
          statusCheck = true;
          archivo.data = resp;
          archivo.uuid = resp.uuid;
          archivo.idArchivoalfresco = resp.idArchivoalfresco;
          console.log("index0000", i);
          return;
        }
        archivo.status = '2';
      })
      // this.myDivInputFile.nativeElement.appendChild(this.myFileInput.nativeElement);
      this.myDivInputFileDisabled = false;
      console.log(this.archivosAlfresco);
      //this.archivosAlfresco.slice(-1)[0].idArchivoAlfresco = resp.data.idArchivoalfresco;
      //this.archivosAlfresco.slice(-1)[0].uuid = resp.data.uuid;
    }, error => {
      console.log("catch getByIdArchivo");
      let index;
      this.archivosAlfresco.forEach(function (archivo, i) {
        console.log("archivo", archivo);
        console.log("index", i);
        if (archivo.status == '0') {
          index = i;
        }
      })
      // remove archivo
      this.archivosAlfresco.splice(index, 1)
      openModalMensaje('Evidencias', 'Tenemos problemas para realizar la carga de archivos.', this.dialog);
      // activar upload
      // this.myDivInputFile.nativeElement.appendChild(this.myFileInput.nativeElement);
      // this.myFileInput.nativeElement.value = "";
      this.myDivInputFileDisabled = false;

    });
  }

  getIframeHTML() {
    const element: HTMLIFrameElement = document.getElementById('uploadiframe') as HTMLIFrameElement;
    let algo = element.contentDocument ? element.contentDocument : element.contentWindow;
    console.log(algo);
  }

}
